// Kaizen Dashboard layouts
import ErrorHandler from "components/ErrorHandler";
import SignIn from "layouts/authentication/sign-in";
import Usuarios from "layouts/usuarios";
//PDFs

// Kaizen Dashboard icons
import {
	Hail,
	Inventory,
	ShoppingCart,
	PointOfSale,
	Restaurant,
	Settings,
	Store,
	BarChart,
	Receipt,
	Person,
	Dashboard,
	FormatListNumbered,
	Payment,
} from "@mui/icons-material";
import RuleIcon from '@mui/icons-material/Rule';
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import GroupIcon from "@mui/icons-material/Group";
import Carta from "layouts/carta";
import Clientes from "layouts/clientes";
import BeneficiosVouchers from "layouts/beneficiosVouchers";
import Cocina from "layouts/cocina";
import OT from "layouts/ordenes-trabajo";
import MateriaPrima from "layouts/materiaPrima";
import Pedidos from "layouts/pedidos";
import Preferncias from "layouts/preferencias";
import Productos from "layouts/productos";
import StockPlatos from "layouts/stockPlatos";
import PantallaScaner from "layouts/pantallaScaner/indexRecepcion";
import PantallaCaja from "layouts/pantallaScaner/indexCaja";
import PantallaBandejas from "layouts/pantallaScaner/indexBandejas";
import Formulario from "layouts/authentication/formulario";
import Convenios from "layouts/convenios";
import Comedor from "layouts/comedor";
import MonitorPedidos from "layouts/monitorPedidos";
import MenuUniversitario from "layouts/menuUniversitario";
import ConfiguracionEventos from "layouts/configuracionEventos";
import EditorEvento from "layouts/configuracionEventos/EditorEvento";
import FlujoEvento from "layouts/configuracionEventos/FlujoEvento";
import TvMenuDiario from "layouts/tv/menu-diario";
import SistemaComedor from "layouts/sistema-comedor";
import Facturas from "layouts/facturas";
import Reportes from "layouts/reportes";
import PantallaMantenimiento from "layouts/pantallaMantenimiento";
import Proveedores from "layouts/authentication/proveedores";
import PerfilProveedor from "layouts/perfilProveedor";
import Compras from "layouts/compras";
import Eventos from "layouts/eventos";
import VentaEvento from "layouts/ventaEvento";
import PantallaClienteVentaEvento from "layouts/ventaEvento/pantallaCliente";

//PDFs compras
import NotaSolicitudPDF from "layouts/PDF/compras/notaSolicitud";
import NotaSecretarioPDF from "layouts/PDF/compras/notaSecretarioAcademico";
import PreventivoPDF from "layouts/PDF/compras/preventivo";
import Licitaciones from "layouts/licitaciones";
import CotizacionProveedor from "layouts/PDF/compras/cotizacionProveedor";
import EvaluacionProcesoContratacion from "layouts/PDF/compras/evaluacionProcesoContratacion";
import PreAdjudicacion from "layouts/PDF/compras/informePreAdjudicacion";
import PreAdjudicacionProveedor from "layouts/PDF/compras/preAdjudicacionProveedor";
import ProcesoContratacionDesierto from "layouts/PDF/compras/procesoContratacionDesierto";
import OP from "layouts/PDF/compras/op";
import PliegoGeneral from "layouts/PDF/compras/pliegoGeneral";
import PliegoParticular from "layouts/PDF/compras/pliegoParticular";
import PliegoParticularConcurso from "layouts/PDF/compras/pliegoParticularConcurso";
import SolicitudGastos from "layouts/PDF/compras/solicitud";
import RankingProcesoContratacion from "layouts/PDF/compras/rankingProcesoContratacion";
import RemitoIndividual from "layouts/PDF/compras/remitoIndividual";
import ActivacionProcesoContratacion from "layouts/PDF/compras/activacionProcesoContratacion";
import AjustePreventivoPDF from "layouts/PDF/compras/ajustePreventivo";
import VoucherAlumnosPdf from "layouts/PDF/clientes/vouchersAlumnos";
import Pagos from "layouts/pagos";
import OrdenPagoPDF from "layouts/PDF/pagos/ordenPago";
import EventosClientes from "layouts/eventoClientes";
// PDFs eventos
import PresupuestoEventoPDFPage from "layouts/PDF/eventos/presupuesto";
import ReportesFinancieros from "layouts/reportesFinancieros";
import SuccessComedor from "components/SuccessComedor";
import ErrorComedor from "components/ErrorComedor";
import Tareas from "layouts/tareas";

// Pantallas habilitadas para cada grupo de documentos PDF de compras.
const PDF_EXPEDIENTE = ["Compras", "Pedidos"];
const PDF_LLAMADO = ["Compras", "Pedidos", "Proveedor"];
const PDF_PROVISION = ["Compras", "Pagos", "Inventario", "Proveedor"];

const routes = [
	// {
	// 	type: "collapse",
	// 	name: "Tareas",
	// 	key: "tareas",
	// 	route: "/tareas",
	// 	icon: <RuleIcon />,
	// 	component: <Tareas />,
	// 	noCollapse: true,
	// 	permiso: "Tareas",
	// },
	{
		type: "collapse",
		name: "Usuarios",
		key: "usuarios",
		route: "/usuarios",
		icon: <GroupIcon />,
		component: <Usuarios />,
		noCollapse: true,
		permiso: "Usuarios",
	},
	{
		type: "collapse",
		name: "Convenios",
		key: "convenios",
		route: "/convenios",
		icon: <GroupIcon />,
		component: <Convenios />,
		noCollapse: true,
		permiso: "Convenio",
	},
	{
		type: "collapse",
		name: "Clientes",
		key: "clientes",
		route: "/clientes",
		icon: <Hail />,
		component: <Clientes />,
		noCollapse: true,
		permiso: "Clientes",
	},
	{
		type: "collapse",
		name: "Beneficios y Vouchers",
		key: "beneficios-vouchers",
		route: "/beneficios-vouchers",
		icon: <Receipt />,
		component: <BeneficiosVouchers />,
		noCollapse: true,
		permiso: "BeneficiosVouchers",
	},
	{
		type: "collapse",
		name: "Productos",
		key: "productos",
		route: "/productos",
		icon: <Restaurant />,
		component: <Productos />,
		noCollapse: true,
		permiso: "Productos",
	},
	{
		type: "collapse",
		name: "Inventario",
		key: "inventario",
		route: "/inventario",
		noCollapse: true,
		icon: <Inventory />,
		component: <MateriaPrima />,
		permiso: "Inventario",
	},
	{
		type: "collapse",
		name: "Inventario Platos",
		key: "inventarioPlatos",
		route: "/inventarioPlatos",
		icon: <Inventory />,
		component: <StockPlatos />,
		noCollapse: true,
		permiso: "InventarioPlatos",
	},
	{
		type: "collapse",
		name: "Men\u00fa universitario",
		key: "menuUniversitario",
		route: "/menuUniversitario",
		icon: <RestaurantMenuIcon />,
		component: <MenuUniversitario />,
		noCollapse: true,
		permiso: "MenuUniversitario",
	},
	{
		type: "collapse",
		name: "Pedidos",
		key: "pedidos",
		route: "/pedidos",
		icon: <Store />,
		component: <Pedidos />,
		noCollapse: true,
		permiso: "Pedidos",
	},
	{
		type: "collapse",
		name: "Eventos",
		key: "eventos",
		route: "/eventos",
		icon: <PointOfSale />,
		component: <Eventos />,
		noCollapse: true,
		permiso: "Eventos",
	},
	{
		type: "collapse",
		name: "Venta evento",
		key: "ventaEvento",
		route: "/venta-evento",
		icon: <PointOfSale />,
		component: <VentaEvento />,
		noCollapse: true,
		permiso: "VentaEvento",
	},
	{
		type: "collapse",
		name: "Configuración de eventos",
		key: "configuracionEventos",
		route: "/configuracion-eventos",
		icon: <PointOfSale />,
		component: <ConfiguracionEventos />,
		noCollapse: true,
		permiso: "ConfiguracionEventos",
	},
	// Asistente de alta/edición: fuera del sidenav, mismo permiso que el listado.
	// "nuevo" y "flujo" van antes que ":id" para que validatePath no los tome como un id.
	{
		type: "hidden",
		name: "Cómo crear un evento",
		key: "configuracionEventosFlujo",
		route: "/configuracion-eventos/flujo",
		component: <FlujoEvento />,
		permiso: "ConfiguracionEventos",
		soloAdministrador: true,
	},
	{
		type: "hidden",
		name: "Nuevo evento",
		key: "configuracionEventosNuevo",
		route: "/configuracion-eventos/nuevo",
		component: <EditorEvento />,
		permiso: "ConfiguracionEventos",
	},
	{
		type: "hidden",
		name: "Editar evento",
		key: "configuracionEventosEditar",
		route: "/configuracion-eventos/:id",
		component: <EditorEvento />,
		permiso: "ConfiguracionEventos",
	},
	// Pantalla al cliente del punto de venta: mismo permiso, pero fuera del
	// sidenav (sólo se dibujan las entradas "collapse") y después de
	// /venta-evento, que sigue siendo la primera ruta permitida del vendedor.
	{
		type: "hidden",
		name: "Pantalla al cliente",
		key: "ventaEventoPantallaCliente",
		route: "/venta-evento/pantalla-cliente",
		component: <PantallaClienteVentaEvento />,
		permiso: "VentaEvento",
	},
	{
		type: "collapse",
		name: "Reportes Financieros",
		key: "reportesFinancieros",
		route: "/reportesFinancieros",
		icon: <PointOfSale />,
		component: <ReportesFinancieros />,
		noCollapse: true,
		permiso: "ReportesFinancieros",
	},
	// {
	// 	type: "collapse",
	// 	name: "Eventos clientes",
	// 	key: "eventosClientes",
	// 	route: "/eventosClientes",
	// 	icon: <PointOfSale />,
	// 	component: <EventosClientes />,
	// 	noCollapse: true,
	// 	permiso: "Eventos",
	// },
	{
		type: "collapse",
		name: "Reportes",
		key: "reportes",
		route: "/reportes",
		icon: <Dashboard />,
		component: <Reportes />,
		noCollapse: true,
		permiso: "Reportes",
	},
	{
		type: "collapse",
		name: "Monitor Pedidos",
		key: "monitorPedidos",
		route: "/monitorPedidos",
		icon: <BarChart />,
		component: <MonitorPedidos />,
		noCollapse: true,
		permiso: "MonitorPedidos",
	},
	{
		type: "collapse",
		name: "Compras",
		key: "compras",
		route: "/compras",
		icon: <ShoppingCart />,
		component: <Compras />,
		noCollapse: true,
		permiso: "Compras",
	},
	{
		type: "collapse",
		name: "Pagos",
		key: "pagos",
		route: "/pagos",
		icon: <Payment />,
		component: <Pagos />,
		noCollapse: true,
		permiso: "Pagos",
	},
	/* Documentos compras */
	// `permisosDocumento` restringe el acceso a la vista sin incorporarla a la
	// navegación ni a la redirección posterior al login (que usan `permiso`).
	// La autorización efectiva de los datos la aplica siempre el backend.
	{
		route: "/nota-solicitud/pdf/:id",
		component: <NotaSolicitudPDF />,
		permisosDocumento: PDF_EXPEDIENTE,
	},
	{
		route: "/nota-secretario-academico/pdf/:id",
		component: <NotaSecretarioPDF />,
		permisosDocumento: PDF_EXPEDIENTE,
	},
	{
		route: "/preventivo/pdf/:id",
		component: <PreventivoPDF />,
		permisosDocumento: PDF_EXPEDIENTE,
	},
	{
		route: "/cotizacion-proveedor/pdf/:id",
		component: <CotizacionProveedor />,
		permisosDocumento: PDF_EXPEDIENTE,
	},
	{
		route: "/evaluacion-proceso-contratacion/pdf/:id",
		component: <EvaluacionProcesoContratacion />,
		permisosDocumento: PDF_EXPEDIENTE,
	},
	{
		route: "/pre-adjudicacion/pdf/:id",
		component: <PreAdjudicacion />,
		permisosDocumento: PDF_EXPEDIENTE,
	},
	{
		route: "/pre-adjudicacionProveedor/pdf/:id",
		component: <PreAdjudicacionProveedor />,
		permisosDocumento: PDF_EXPEDIENTE,
	},
	{
		route: "/proceso-contratacion-desierto/pdf/:id",
		component: <ProcesoContratacionDesierto />,
		permisosDocumento: PDF_EXPEDIENTE,
	},
	{
		route: "/op/pdf/:id",
		component: <OP />,
		permisosDocumento: PDF_PROVISION,
	},
	{
		route: "/pliego-general/pdf/:id",
		component: <PliegoGeneral />,
		permisosDocumento: PDF_LLAMADO,
	},
	{
		route: "/pliego-particular/pdf/:id",
		component: <PliegoParticular />,
		permisosDocumento: PDF_LLAMADO,
	},
	{
		route: "/pliego-particular-concurso/pdf/:id",
		component: <PliegoParticularConcurso />,
		permisosDocumento: PDF_LLAMADO,
	},
	{
		route: "/solicitud/pdf/:id",
		component: <SolicitudGastos />,
		permisosDocumento: [...PDF_LLAMADO, "Inventario"],
	},
	{
		route: "/ranking-proceso-contratacion/pdf/:id",
		component: <RankingProcesoContratacion />,
		permisosDocumento: PDF_LLAMADO,
	},
	{
		route: "/remitoIndividual/pdf/:id",
		component: <RemitoIndividual />,
		permisosDocumento: PDF_PROVISION,
	},
	{
		route: "/vouchers-alumnos/pdf/uso-total",
		component: <VoucherAlumnosPdf />,
		permisosDocumento: ["Clientes", "BeneficiosVouchers"],
	},
	{
		route: "/activacion-proceso-contratacion/pdf/:id",
		component: <ActivacionProcesoContratacion />,
		permisosDocumento: PDF_EXPEDIENTE,
	},
	{
		route: "/ajuste-preventivo/pdf/:id",
		component: <AjustePreventivoPDF />,
		permisosDocumento: PDF_EXPEDIENTE,
	},
	{
		route: "/orden-pago/pdf/:id",
		component: <OrdenPagoPDF />,
		permisosDocumento: ["Pagos"],
	},
	{
		route: "/presupuesto-evento/pdf/:id",
		component: <PresupuestoEventoPDFPage />,
		permisosDocumento: ["Eventos"],
	},
	{
		type: "collapse",
		name: "Perfil",
		key: "perfil",
		route: "/perfil",
		icon: <Person />,
		component: <PerfilProveedor />,
		noCollapse: true,
		permiso: "Proveedor",
	},
	{
		type: "collapse",
		name: "Cotizaciones",
		key: "cotizaciones",
		route: "/cotizaciones",
		icon: <FormatListNumbered />,
		component: <Licitaciones />,
		noCollapse: true,
		permiso: "Proveedor",
	},
	// {
	//   type: "collapse",
	//   name: "Preferencias",
	//   key: "preferencias",
	//   route: "/preferencias",
	//   icon: <Settings />,
	//   component: <Preferncias />,
	//   noCollapse: true,
	//   permiso: "Preferencias",
	// },
	// {
	//   type: "collapse",
	//   name: "Facturas",
	//   key: "facturas",
	//   route: "/facturas",
	//   icon: <Receipt />,
	//   component: <Facturas />,
	//   noCollapse: true,
	//   permiso: "Facturas",
	// },
	{
		name: "Carta",
		route: "/carta",
		component: <Carta />,
	},
	{
		route: "/carta/:categoria",
		component: <Carta />,
	},
	{
		name: "Cocina",
		route: "/cocina",
		component: <Cocina />,
	},
	{
		name: "Ordenes de trabajo",
		route: "/ordenes-trabajo",
		component: <OT />,
	},
	{
		name: "Tv Menu Diario",
		route: "/tv-menu-diario",
		component: <TvMenuDiario />,
	},
	// Totem deshabilitado: su pantalla ya no es pública. Las rutas /totem, /successTotem y
	// /errorTotem se quitaron; los componentes se conservan para reactivarlo.
	{
		name: "SuccessComedor",
		route: "/successComedor",
		component: <SuccessComedor />,
	},
	{
		name: "ErrorComedor",
		route: "/errorComedor",
		component: <ErrorComedor />,
	},
	{
		name: "Comedor Alumnos",
		route: "/comedorAlumnos",
		component: <Comedor />,
	},
	{
		name: "Sistema Comedor",
		route: "/sistema-comedor",
		component: <SistemaComedor />,
	},
	{
		name: "Pantalla recepci\u00f3n",
		route: "/recepcion",
		component: <PantallaScaner />,
	},
	{
		name: "Pantalla caja",
		route: "/cajaRecepcion",
		component: <PantallaCaja />,
	},
	{
		name: "Pantalla bandejas",
		route: "/bandejasRecepcion",
		component: <PantallaBandejas />,
	},
	{
		route: "/error",
		component: <ErrorHandler />,
	},
	{
		route: "/proveedores",
		component: <Proveedores />,
	},
	{
		route: "/login",
		component: <SignIn />,
	},
	{
		route: "/formulario",
		component: <Formulario />,
	},
	{
		route: "/mantenimiento",
		component: <PantallaMantenimiento />,
	},
];

export default routes;
